import { useQuery } from '@tanstack/react-query';
import { Lecture } from '#types/lectures';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

export interface GetLectureList {
  rounds: number;
  id: string;
  title: string;
  body: string;
}

/**
 * 수업 검색 - 수업 이름, 코치 이름
 * @link https://api-dev.fibud.kr/api#/%EC%88%98%EC%97%85/LecturesController_getLecturesForCoachByName
 * @param coachId
 * @param query
 * @returns
 */
export const useLectureSearchQuery = (coachId?: string, query?: string) => {
  return useQuery(
    [queryKeys.LECTURE, coachId, query],
    () =>
      fetcher<Lecture[]>(
        `/lectures/search?coachId=${coachId}&title=${query ?? ''}`
      ),
    {
      enabled: !!coachId
    }
  );
};
